export default __webpack_public_path__ + "static/media/up-disabled.0cb6d749.svg";